import { createStyles, makeStyles } from '@material-ui/styles';
import {
  Button, Grid, Theme, Typography,
} from '@material-ui/core';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import clsx from 'clsx';
import { push } from 'connected-react-router';

import { selectRegistrationForm } from '../../store/modules/registration/selectors';
import { ExclamationCircleIcon } from '../../components/icon/solid';
import { Link, PagesTitle } from '../../components';
import { useTitle } from '../../hooks';
import { Links } from '../../utility/links';
import PageContainer from './PageContainer';

const useStyles = makeStyles(({ palette }: Theme) => createStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  icon: {
    height: '64px',
    width: '64px',
    color: palette.error.main,
  },
  title: {
    marginTop: '56px',
    marginBottom: '24px',
  },
  email: {
    fontWeight: 600,
  },
  body: {
    color: palette.text.secondary,
    textAlign: 'center',
    fontSize: '16px',
    paddingBottom: '16px',

    '& p': {
      marginBlockStart: 0,
      marginBlockEnd: 0,
    },
  },
  button: {
    borderRadius: '5px',
    borderWidth: '1.5px',
    minWidth: '170px',

    fontFamily: 'Montserrat',
    fontSize: '16px',
    fontWeight: 600,
    textTransform: 'none',
    margin: '42px 12px 42px 12px',
  },
  buttonLink: {
    '&:hover': {
      textDecoration: 'none',
    },
  },
  support: {
    color: palette.menuAction.selected,
    borderColor: palette.menuAction.selected,
  },
  retry: {
    color: palette.primary.main,
    borderColor: palette.primary.main,
  },
}), { name: 'RegistrationError' });

const RegistrationError = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  useTitle('Registration Error');

  const { email } = useSelector(selectRegistrationForm);
  useEffect(() => {
    if (!email) {
      dispatch(push('/'));
    }
  }, [dispatch, email]);

  return (
    <PageContainer>
      <Grid container className={classes.root}>
        <ExclamationCircleIcon className={classes.icon} />
        <PagesTitle className={classes.title}>Registration Error</PagesTitle>
        <Typography variant="body1" component="div" className={classes.body}>
          <p>There was a problem registering this email address:</p>
          <p className={classes.email}>{email}</p>
        </Typography>
        <Typography variant="body1" component="div" className={classes.body}>
          <p>Please try a different email address</p>
          <p>or contact customer support.</p>
        </Typography>
        <Grid item xs={12}>
          <Link to={Links.support} defaultAction target="_blank" className={classes.buttonLink}>
            <Button
              variant="outlined"
              className={clsx(classes.button, classes.support)}
            >
              Customer Support
            </Button>
          </Link>
          <Link to="/pages/register" className={classes.buttonLink}>
            <Button
              variant="outlined"
              className={clsx(classes.button, classes.retry)}
            >
              Try Again
            </Button>
          </Link>
        </Grid>
      </Grid>
    </PageContainer>
  );
};

export default RegistrationError;
